import { LoyaltyPointTransfer, LoyaltyPointTransferAdd } from './../../models/loyalty-point-transfer.model';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';
import { AcmHasLayout } from '../../models/loyalty-acm.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { PointTransferModel } from 'app/models/loyalty-card.model';

@Injectable()
export class LoyaltyPointTransferService {

  public baseUrl = '/koncentro-loyalty';

  constructor(
    private http: HttpClientService
  ) { }

  list(offset = null, 
    limit = null,
     search?: Array<{ key: string, value: string }>,
     globalSearch?: string,
     sort?: string,
     sort_dir?: number): Observable<{ data: Array<LoyaltyPointTransfer>, metadata: ListMetadata }> {
      const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/movement/pointTransfer?' + params.toString());
  }
  create(pointTransferAdd: any, companyCode: number): Observable<LoyaltyPointTransferAdd> {
    return this.http.post(` /koncentro-api/kloy/pointTransfer?companyCode=${companyCode}`, pointTransferAdd);
  }
  remove(id): Observable<any> {
    return this.http.delete(this.baseUrl + '/movement/pointTransfer/'+id);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-point-transfers.service.ts